import { DietModeType } from '@front-activerse/common-components';
import { validateVariablesType } from '../types';

const createRequest = (values: any) => {
  const { weightValue, weightUnit, dietMode, goalWeightUnit, goalWeightValue } = values;

  const calculateGoalWeight = () => {
    if (dietMode === null && dietMode === null) {
      return { value: weightValue, unit: weightUnit };
    } else if (dietMode !== DietModeType.stabilization) {
      if (goalWeightValue) {
        return { value: goalWeightValue, unit: goalWeightUnit };
      } else {
        return null;
      }
    } else {
      return { value: weightValue, unit: weightUnit };
    }
  };

  const goalWeight = calculateGoalWeight();

  const variables: validateVariablesType = {
    weight: weightValue ? { value: weightValue, unit: weightUnit } : null,
    dietMode: dietMode ? dietMode : DietModeType.stabilization,
    goalWeight,
  };

  return variables;
};

export default createRequest;
